<template>
  <div class="salesmanGiftAddressPage" >
    <div class="pageContent">
      <XR-head titleText="填收货地址" :rightShow="false" ref="headObj"></XR-head>

      <router-link to="/usercenter/address?redirecturl=/salesman/giftAddress">
        <div class="receive-address">          
          <div class="mapIcon">
            <i class="fa fa-location"></i>
          </div>
          <div class="address-info" :style="{width:addressInfoWidth+'px'}">
            <div class="contract">
              <span class="name">{{receiveAddress.Receiver}}</span>
              <span class="mobile">{{receiveAddress.Phone}}</span>
            </div>
            <div class="address-content">
              <span class="text">{{receiveAddress.DetailAddress}}</span>
            </div>
          </div>
          <div class="goIcon">
            <i class="fa fa-angle-right"></i>
          </div>
        </div>
      </router-link>

      <div class="choose-info delivery"  @click="open('delivery')">
        <div class="info left">
          <div class="choose-row title">选择配送</div>
        </div>    
        <div class="goIcon">
          <i class="fa fa-angle-right"></i>
        </div> 
        <div class="info center" :style="{width:chooseInfoWidth+'px'}">
          <div class="choose-row">{{shippingMethodName}}</div>
          <div class="choose-row">{{shippingDateName}}</div>
        </div>
        <mu-popup position="bottom" popupClass="salesmanGiftAddressPage-popupLayer delivery" :open="deliveryPopup" @close="close('delivery')">
          <mu-sub-header>请选择送货方式</mu-sub-header>
          <div class="deliveryChoose">
            <template v-for="methodItem in shippingMethodList">
              <mu-raised-button :label="methodItem.method" :class="shippingMethodInfo.id==methodItem.Id?'shippingBtn select':''" @click="selectShippingMethod(methodItem.Id,methodItem.method)"></mu-raised-button>
            </template>
          </div>
          <mu-sub-header>请选择送货时间</mu-sub-header>
          <div class="deliveryChoose">
            <template v-for="dateItem in shippingDateList">
              <mu-raised-button :label="dateItem.method" :class="shippingDateInfo.id==dateItem.Id?'shippingBtn select':''" @click="selectShippingDate(dateItem.Id,dateItem.method)"></mu-raised-button>
            </template>
          </div>
          <mu-raised-button primary @click="choseDelivery()" fullWidth class="delvieryChooseBtn" label="确定"/>
        </mu-popup>
      </div>

      <div class="bottom-bar">
        <mu-row >
          <mu-col width="100" tablet="100" desktop="100">
            <mu-raised-button label="确 定" class="gobuy" primary fullWidth @click="submit"></mu-raised-button>
          </mu-col>
        </mu-row>
      </div>
    </div>
    <XR-toast @onClose="submitSuccess" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import cart from '../../util/cart'
export default {
  data () {
    return {
      cartItemProductInfoWidth: (parseInt(document.documentElement.clientWidth)-130),
      addressInfoWidth: (parseInt(document.documentElement.clientWidth)-70) ,
      chooseInfoWidth: (parseInt(document.documentElement.clientWidth)-190) ,      
      deliveryPopup: false,
      receiveAddress :{},
      shippingMethodInfo:{id:0,name:''},
      shippingDateInfo:{id:0,name:''},
      shippingMethodName:'',
      shippingDateName:'',
      shippingMethodList:[],
      shippingDateList:[],
      ungetInfo:{
        shippingMethodId:0,
        shippingDateId:0,
        addrId:0
      }
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()
    this.getDefaultAddress()
    this.getShippingDateList()
    this.getShippingMethodList()
  },
  methods: {
    open (obj) {
      this[obj+'Popup'] = true
      if(obj == 'delivery'){
        this.shippingMethodInfo.id = this.ungetInfo.shippingMethodId
        this.shippingMethodInfo.name = this.shippingMethodName
        this.shippingDateInfo.id = this.ungetInfo.shippingDateId
        this.shippingDateInfo.name = this.shippingDateName
      }
    },
    close (obj) {
      this[obj+'Popup'] = false
    },
    closeChoose(obj){
      this[obj+'Popup'] = false
    },    
    getDefaultAddress(){
      var ths = this
      ths.$post(
        "/Shop/UserServer/GetDefaultReceiveAddress"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.$refs.XRtoast.hide()
          ths.receiveAddress = res.Data
          ths.ungetInfo.addrId = res.Data.Id
          ths.loaded = false
        }
      });
    },
    getShippingDateList(){    
      var ths = this  
      ths.$post(
        "/Shop/RetailServer/GetShippingDateList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.shippingDateList = res.Data
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },
    getShippingMethodList(){   
      var ths = this 
      ths.$post(
        "/Shop/RetailServer/GetShippingMethodList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.shippingMethodList = res.Data
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },
    selectShippingDate(id, name){
      this.shippingDateInfo.id = id
      this.shippingDateInfo.name = name
    },
    selectShippingMethod(id, name){
      this.shippingMethodInfo.id = id
      this.shippingMethodInfo.name = name
    },
    choseDelivery(){
      this.ungetInfo.shippingMethodId = this.shippingMethodInfo.id
      this.shippingMethodName = this.shippingMethodInfo.name
      this.ungetInfo.shippingDateId = this.shippingDateInfo.id
      this.shippingDateName = this.shippingDateInfo.name
      this.close('delivery')
    },
    submit(){
      if(this.ungetInfo.addrId ==0){
        this.$refs.XRtoast.failed("请选择收货地址", true)
        return
      }
      if(this.ungetInfo.shippingMethodId==0){
        this.$refs.XRtoast.failed("请选择配送方式", true)
        return
      }
      if(this.ungetInfo.shippingDateId==0){
        this.$refs.XRtoast.failed("请选择配送时间", true)
        return
      }

      var ths = this
      ths.$post(
        "/Salesman/SalesmanServer/UnGetGift",
        JSON.stringify(this.ungetInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    submitSuccess(){
      this.$router.push('/salesman/index')
    }
  }
}
</script>
<style>
body .salesmanGiftAddressPage{
  background: #F0F2F5;
  bottom: unset;
}
.pageContent{
  padding-bottom: 56px;
}

.salesmanGiftAddressPage .goIcon{
  width: 20px;
  float: right;
  text-align: right;
}

.salesmanGiftAddressPage .mapIcon{
  float: left;
  width: 30px;
  line-height: 64px;
}

.salesmanGiftAddressPage .receive-address{
  background: white;
  color:black;
  padding: 10px;
  overflow: hidden;
}
.salesmanGiftAddressPage .receive-address .address-info{
  float: left;
}
.salesmanGiftAddressPage .receive-address .address-info .name{
  font-size:16px;
  font-weight: 700;
  padding-right: 15px;
}
.salesmanGiftAddressPage .receive-address .address-info .mobile{
  font-size:16px;
  font-weight: 700;
}
.salesmanGiftAddressPage .receive-address .address-info .address-content{
  font-size:12px;
  line-height: 18px;
  color:#999;
}
.salesmanGiftAddressPage .receive-address .address-info .address-content .fa{
  width: 20px;
}
.salesmanGiftAddressPage .receive-address .goIcon{
  line-height: 64px;
}

.salesmanGiftAddressPage .choose-info{
  overflow: hidden;
  padding:10px;
  background: white;
  margin-top: 10px;
}
.salesmanGiftAddressPage .choose-info .info{
  font-size: 12px;
  float: left;
  line-height: 24px;
}
.salesmanGiftAddressPage .choose-info .info.center{
  float: right;
}
.salesmanGiftAddressPage .choose-info .info.left {
  width: 150px;
}
.salesmanGiftAddressPage .choose-info .info.left .title{
  font-size: 14px;
  font-weight: 700;
}
.salesmanGiftAddressPage .choose-info .info .choose-row{
  line-height: 24px;
}
.salesmanGiftAddressPage .choose-info .info.center .choose-row{
  text-align: right;
}
.salesmanGiftAddressPage .choose-info.integral .info.left .choose-row.balance{
  color:red;
}
.salesmanGiftAddressPage .choose-info .goIcon{
  line-height: 48px;
}

.salesmanGiftAddressPage .remark{
  background: white;
  margin-top: 10px;
  padding:10px 10px 0;
}

.salesmanGiftAddressPage .price-info{
  background: white;
  margin-top: 10px;
  padding:10px 10px 40px;
}
.salesmanGiftAddressPage .price-info .row{
  background: white;
  overflow: hidden;
  line-height: 32px;
}
.salesmanGiftAddressPage .price-info .row .title{
  font-size: 14px;
  font-weight: 700;
}
.salesmanGiftAddressPage .price-info .row .price{
  color:Red;
  font-weight: 700;
}



.salesmanGiftAddressPage .pro-list{
  margin-top: 10px;
  background: white;
  overflow: hidden;
}
.salesmanGiftAddressPage .pro-list .pro-item{
  padding: 16px 0;
  overflow: hidden;
}
.salesmanGiftAddressPage .pro-list .pro-item .pro-img{
  width: 80px;
  float: left;
}
.salesmanGiftAddressPage .pro-list .pro-item .pro-img img{
  width: 100%;
  display: block;
  border-radius: 4px;
  margin: 0 20px;
}
.salesmanGiftAddressPage .pro-list .pro-item .pro-info{
  float: right;
  padding-right: 10px;
}
.salesmanGiftAddressPage .pro-list .pro-item .pro-info .pro-name{
  font-size: 12px;
  line-height: 16px;
  height: 32px;
  padding-bottom: 4px;
  overflow: hidden;
}
.salesmanGiftAddressPage .pro-list .pro-item .pro-info .pro-attr{
  font-size: 12px;
  line-height: 16px;
  height: 30px;
  color:#999;
}
.salesmanGiftAddressPage .pro-list .pro-item .pro-info .pro-num{
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  color:#999;
}
.salesmanGiftAddressPage .pro-list .pro-item .pro-info .pro-num .pro-price{
  font-size: 16px;
  line-height: 16px;
  float: left;
  color:red;
}
.salesmanGiftAddressPage .pro-list .pro-item .pro-info .pro-num .count{
  font-size: 12px;
  line-height: 16px;
  color:#999;
  float: right;
}




.salesmanGiftAddressPage .bottom-bar{  
  margin-top: 50px;
  height: 56px;
  border-top:1px solid #eee;
  padding: 0 10%;
}
.salesmanGiftAddressPage .gobuy{
  width: 100%;
  line-height: 50px;
  height: 50px;
  text-align: center;
}

.salesmanGiftAddressPage-popupLayer {
  width: 100%;
  min-height: 120px;
}
.salesmanGiftAddressPage-popupLayer .deliveryChoose {
  padding: 0 10px;
}
.salesmanGiftAddressPage-popupLayer .delvieryChooseBtn{
  margin: 40px 0 0;
  height: 50px; 
}

.salesmanGiftAddressPage-popupLayer .shippingBtn.select{
  background: red;
  color:white;
}

</style>



// WEBPACK FOOTER //
// src/pages/salesman/salesmanGiftAddress.vue